import createIcon from '../../createIcon';

/**
 * @component @name ReportGmailerrorred
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzMgM0g4LjI3TDMgOC4yN1YxNS43M0w4LjI3IDIxSDE1LjczTDIxIDE1LjczVjguMjdMMTUuNzMgM1pNMTkgMTQuOUwxNC45IDE5SDkuMUw1IDE0LjlWOS4xTDkuMSA1SDE0LjlMMTkgOS4xVjE0LjlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgN0gxMVYxM0gxM1Y3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzIDE1SDExVjE3SDEzVjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReportGmailerrorred = createIcon('ReportGmailerrorred', [
  [
    'path',
    {
      d: 'M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9Z',
      key: 'thxabn',
    },
  ],
  ['path', { d: 'M13 7H11V13H13V7Z', key: '10p7cl' }],
  ['path', { d: 'M13 15H11V17H13V15Z', key: '1baev7' }],
]);

export default ReportGmailerrorred;
